export const BillIcon = ({
  color,
  width = 37,
  height
}: {
  color: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={`${width}`}
      height={`${height ?? width * (4 / 3.7)}`}
      viewBox="0 0 37 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6329 20.5809C23.8429 20.0409 25.1729 19.7409 26.5829 19.7409H26.6029C31.9929 19.7409 36.3729 24.1209 36.3729 29.5109C36.3729 34.9009 31.9929 39.2809 26.6029 39.2809C21.2129 39.2809 16.8329 34.9009 16.8329 29.5109V29.4209H2.03287C1.26287 29.4209 0.632868 28.7909 0.632868 28.0209V6.90086C0.612868 6.45086 0.602868 4.04086 2.34287 2.17086C3.68287 0.730865 5.65287 0.000864634 8.20287 0.000864634H8.26287H24.6029H24.9329C25.4229 -0.00913537 26.6829 0.0508648 27.8129 1.09086C29.0929 2.27086 29.6929 4.23086 29.6029 6.91086V14.7109C29.6029 15.4809 28.9729 16.1109 28.2029 16.1109H22.6329V20.5809ZM26.7929 13.3109V6.86087C26.8529 5.07087 26.5529 3.79087 25.9429 3.19087C25.5475 2.80516 25.115 2.80997 25.0397 2.81081C25.037 2.81084 25.0347 2.81087 25.0329 2.81087H24.9429H24.9029H24.3929C22.8029 3.03087 22.5929 6.54086 22.6229 7.48086V13.3109H26.7929ZM3.41287 6.86087V26.6109H17.2429C17.7529 24.9909 18.6729 23.5609 19.8729 22.4209C19.8429 22.3109 19.8229 22.2009 19.8229 22.0809V7.53087C19.7729 6.20087 19.9629 4.34087 20.6529 2.80086H8.23287H8.18287C6.44287 2.80086 5.16287 3.23086 4.37287 4.08086C3.35845 5.17332 3.40961 6.66536 3.41274 6.75666C3.41282 6.75896 3.41287 6.76037 3.41287 6.76086V6.86087ZM18.8029 29.5109C18.8029 33.7909 22.2929 37.2809 26.5729 37.2809V37.2909C30.8529 37.2909 34.3429 33.8009 34.3429 29.5209C34.3429 25.2409 30.8529 21.7509 26.5729 21.7509C24.8729 21.7509 23.2929 22.3109 22.0129 23.2409H22.0029C20.0629 24.6609 18.8029 26.9409 18.8029 29.5109ZM28.215 27.8868C28.215 27.0721 27.5081 26.4102 26.638 26.4102L26.6198 26.3932C25.7498 26.3932 25.0428 27.0552 25.0428 27.8699C25.0428 28.6846 25.7498 29.3465 26.6198 29.3465C28.2785 29.3465 29.6198 30.611 29.6198 32.1556C29.6198 33.4625 28.6591 34.5488 27.363 34.8628L27.3359 35.372C27.3177 35.7284 27.0005 36 26.6289 36H26.5927C26.2029 35.983 25.9038 35.669 25.922 35.3041L25.9491 34.8883C24.6259 34.5997 23.638 33.488 23.638 32.1641C23.638 31.7992 23.9552 31.5021 24.3449 31.5021C24.7346 31.5021 25.0519 31.7992 25.0519 32.1641C25.0519 32.9788 25.7588 33.6407 26.6289 33.6407C27.499 33.6407 28.2059 32.9788 28.2059 32.1641C28.2059 31.3494 27.499 30.6874 26.6289 30.6874C24.9703 30.6874 23.6289 29.4229 23.6289 27.8784C23.6289 26.5545 24.6168 25.4427 25.9401 25.1542C25.9463 24.9023 25.9569 24.7717 25.9629 24.6982C25.9655 24.6652 25.9673 24.6438 25.9673 24.628C25.9854 24.2801 26.2845 24 26.6742 24C27.064 24 27.3812 24.297 27.3812 24.662V24.7808C27.3812 24.782 27.3808 24.7846 27.3802 24.789C27.3764 24.8158 27.363 24.9093 27.363 25.1711C28.6591 25.4767 29.6289 26.5799 29.6289 27.8868C29.6289 28.2518 29.3117 28.5488 28.922 28.5488C28.5322 28.5488 28.215 28.2518 28.215 27.8868Z"
        fill={color}
      ></path>
      <path
        className="listra-horizontal"
        d="M6.62891 14H16.6289"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      ></path>
      <path
        className="listra-horizontal"
        d="M6.62891 8H16.6289"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      ></path>
      <path
        className="listra-horizontal"
        d="M6.62891 21H16.6289"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      ></path>
    </svg>
  );
};
